module.exports = __webpack_public_path__ + "b767bc08ba3ea466880a1b375deabcea.svg";


//////////////////
// WEBPACK FOOTER
// ./js/sport-betting/components/pages/GamesPageNewLayout/assets/recent.svg
// module id = 1784
// module chunks = 2